import { ElementType } from "../../library-js/dom-tools/ElementType";
import { ContextMenu } from "./ContextMenu";
import { ContextMenuItem } from "./ContextMenuItem";

export class ContextMenuSubMenu extends ContextMenuItem
{
  static readonly type = new ElementType<HTMLElement>( "context--menu--sub--menu" );
  
  _subMenu:ContextMenu;

  constructor( parent:ContextMenu, subMenu:ContextMenu )
  {
    super( parent );
    this._subMenu = subMenu;
    this.create();
  }

  _create():void
  {
    this._createElement( ContextMenuSubMenu.type, this._subMenu.cloneHeader() );
  }
  
}